import { makeStyles } from "@material-ui/core";
import React from "react";

import { BORDER_SUBTLE, TEXT_DEFAULT } from "../../styles/colors";
import { FONT_MED } from "../../styles/fonts";

interface SectionCardBadgeProps {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export default function SectionCardBadge({
  children,
  className = "",
  dataTestId,
}: SectionCardBadgeProps) {
  const classes = useStyles();

  return (
    <span className={`${classes.root} ${className}`} data-testid={dataTestId}>
      {children}
    </span>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: `solid 1px ${BORDER_SUBTLE}`,
    borderRadius: 4,
    padding: "5px 6px 3px 7px",
    backgroundColor: "#FFFFFF",
    color: TEXT_DEFAULT,
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    ...FONT_MED,
  },
}));
